export default __webpack_public_path__ + "static/media/coreacert.f6840937.png";